<footer class="main-footer text-center">
    <strong>Copyright &copy; {{currentYear}}
        <a href="http://nybsys.com">Nybsys</a>.</strong> All rights reserved.
</footer>
